import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-update-cart]';
const PLUGIN_NAME = 'UpdateCart';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--update-cart" */ './update-cart'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/update-cart/index.js